<template>
  <div>
    <div
      :style="styles"
      class="ts-divider"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue';

defineOptions({
  name: 'DividerBlock',
});
const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const styles = computed(() => {
  const divider = props.config?.divider ?? {};
  return {
    borderBottom: `solid ${divider.thickness ?? 0}px ${divider.color?.hex ?? ''}`,
    width: `${divider.width ?? 100}%`,
  };
});
</script>

<style scoped>
.ts-divider {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  display: block;
  clear: both;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
